import React, { useEffect, useState, useRef } from 'react';
import { graphql, navigate, useStaticQuery } from 'gatsby';
import { useCookies } from 'react-cookie';
import CloseIcon from '../../assets/images/alert-close.svg';
import SmallLine from '../../assets/images/small-line.svg';
import { inBuildEnv } from '../../helpers/inBuildEnv';

function displayScroll(show = '') {
  const html = !inBuildEnv() ? document.querySelector('html') : null;

  if (html == null) {
    return;
  }
  html.style.overflowY = show || undefined;
}

let buttonSet = true;
let alertPage = false;

function AlertModal() {
  const data = useStaticQuery(graphql`
    {
      wp(acfOptionsAlertModal: { alertModalOptions: {} }) {
        acfOptionsAlertModal {
          alertModalOptions {
            alertModalButtonLink {
              ... on WpPage {
                id
                link
              }
            }
            alertModalButtonText
            alertModalDate
            alertModalHeading
            alertModalBody
            alertModalSpecificPages {
              ... on WpPage {
                uri
              }
            }
            showAlertModal
          }
        }
      }
    }
  `);

  let {
    wp: {
      acfOptionsAlertModal: {
        alertModalOptions: {
          alertModalHeading,
          alertModalBody,
          alertModalButtonLink,
          alertModalButtonText,
          showAlertModal,
          alertModalSpecificPages,
          alertModalDate,
        },
      },
    },
  } = data;
  let animationContainerHeight = useRef(null);

  // cookies
  const showCookie = 'alert: enabled';
  const timeCookie = 'alert: timeout';
  const vCookie = 'alert: version';
  const cookieAge = 60 * 60 * 24 * 7; // (seconds in a week;)----
  const cookieOptions = { path: '/', maxAge: cookieAge };

  const [displayModal, setDisplayModal] = useState(false);
  const [cookies, setCookie] = useCookies([showCookie, timeCookie, vCookie]);

  // check if page is the correct page
  const urls = [];
  const currentVersion = alertModalDate;

  // put all our pages that the user selected in the cms into an array of urls

  for (let i = 0; i < alertModalSpecificPages?.length; i++) {
    if (alertModalSpecificPages[i]['uri'] == undefined) {
      continue;
    }
    urls.push(alertModalSpecificPages[i]['uri']);
  }

  // if our current location = one of the page urls.
  const pathName = !inBuildEnv() ? location.pathname : false;

  if (showAlertModal == true || urls.includes(pathName)) {
    alertPage = true;
  }

  useEffect(() => {
    let delayTimer = setTimeout(() => {
      let showAlert = false;

      if (alertPage == true) {
        const today = new Date();
        const todayPlusHour = today.setTime(
          today.getTime() + 1 * 60 * 60 * 1000
        ); //3600000 an hour
        const currentTime = new Date();

        if (
          cookies[showCookie] == undefined ||
          cookies[showCookie] == 'true' ||
          currentTime.getTime() > cookies[timeCookie] ||
          cookies[vCookie] !== currentVersion
        ) {
          setCookie(timeCookie, todayPlusHour, cookieOptions);
          setCookie(vCookie, currentVersion, cookieOptions);
          setCookie(showCookie, true, cookieOptions);
          showAlert = true;
        }
      }

      setDisplayModal(showAlert);
    }, 100);
    return () => {
      clearTimeout(delayTimer);
    };
  }, []);

  useEffect(() => {
    if (displayModal) {
      displayScroll('hidden');
    } else {
      displayScroll('');
    }
  }, [displayModal]);

  function closeModal() {
    return new Promise((result) => {
      closeAnimations();
      setTimeout(() => {
        result('done');
      }, 550);
    }).then(() => {
      setCookie(showCookie, false, cookieOptions);
      setDisplayModal(false);
    });
  }

  function quickClose() {
    const animationContainer = document.querySelector(
      '.alert__animationContainer'
    );
    animationContainer.display = 'none';
    setCookie(showCookie, false, cookieOptions);
    setDisplayModal(false);
  }

  function closeAnimations() {
    const contentText = document.querySelector('.alert__animationText');
    contentText.style.opacity = '0';

    setTimeout(() => {
      const animationContainer = document.querySelector(
        '.alert__animationContainer'
      );
      animationContainer.style.transform = 'translate(-50%, -50%) scale(0)';

      const animationOverlay = document.querySelector(
        '.alert__animationOverlay'
      );
      animationOverlay.style.backgroundColor = 'transparent';
    }, 330);
  }

  if (
    alertModalButtonText == '' ||
    alertModalButtonText == undefined ||
    alertModalButtonText == null ||
    alertModalButtonLink == undefined ||
    alertModalButtonLink == null
  ) {
    buttonSet = false;
  }

  return displayModal == false ? null : (
    <div className="alert__animationOverlay alert__overlay">
      <div
        className="alert__animationContainer  alert__animationContainerHeight alert__box-container "
        ref={animationContainerHeight}
      >
        <div className="alert__container">
          <div className="alert__animationText">
            <div
              role="button"
              tabIndex={0}
              className="alert__close"
              onClick={() => {
                closeModal();
              }}
              onKeyDown={() => {
                closeModal();
              }}
            >
              <img
                src={CloseIcon}
                alt="Alert Icon"
                className=""
                width="20px"
                height="20px"
              />
            </div>
            <div className="alert__title">
              <div>{alertModalHeading}</div>
            </div>
            <div className="alert_small-line">
              {' '}
              <img
                src={SmallLine}
                alt="Small Line"
                className=""
                width="40px"
                height="2px"
              />
            </div>
            <div className="alert__body">
              <div dangerouslySetInnerHTML={{ __html: alertModalBody }} />
            </div>
            {buttonSet ? (
              <button
                type="button"
                className="button alert__button"
                onClick={() => {
                  closeModal().then(() => {
                    navigate(alertModalButtonLink.link);
                  });
                }}
                onKeyDown={() => {
                  quickClose();
                }}
              >
                <div>{alertModalButtonText}</div>
              </button>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AlertModal;
